import { IdentificationNumbers } from 'modules/onboarding/common/components';

import { useIdentificationNumbers } from '../hooks';
import { PageComponentProps } from '../types';

export const IdentificationNumbersStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { submitLoading, onSubmit, goToBack, initialValues } =
    useIdentificationNumbers();

  return (
    <IdentificationNumbers
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
